import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import Reveal from "./reveal"

const Service = ({ title, desc, img, new_or_not, index }) => {
  return (
    <div className="px-8 flex flex-col md:flex-row md:items-center alternateFlex my-8 md:my-20 justify-between max-w-6xl mx-auto md:gap-x-6">
      <div className="md:w-2/5">
        <div className="flex flex-col">
          <h5 className="text-3xl md:text-3xl font-light opacity-40 text-white">
            0{index + 1}
          </h5>
        </div>
        <div className="flex items-center mb-2">
          <h5 className="text-white text-2xl mb-3">{title}</h5>
        </div>
        <Reveal once={false} dur={0.6} threshold={1}>
          <p className="md:max-w-sm text-xl md:text-lg mb-12 md:mb-4 text-white antialiased">
            {desc}
          </p>
        </Reveal>
      </div>
      <Reveal
        once={false}
        dur={0.6}
        threshold={0.5}
        y={20}
        className="md:max-w-lg md:w-3/5 w-full"
      >
        <Img fluid={img} className="rounded-lg" />
      </Reveal>
    </div>
  )
}

export default function Services() {
  const data = useStaticQuery(graphql`
    query ServicesQuery {
      prismicHomepage{
        data{
          services_title {
          text
        }
        }
      }
      prismicHomepageBodyService {
        items {
          new_or_not
          image {
            fluid {
              ...GatsbyPrismicImageFluid_noBase64
            }
          }
          description {
            text
          }
          title {
            text
          }
        }
      }
    }
  `)
  const servicesTitle = data.prismicHomepage.data["services_title"].text
  return (
    <div className="bg-blue">
      <div className="smileCurve bg-white h-60 md:h-72 pt-16 md:pt-1">
        <h1 className="max-w-sm md:max-w-xl text-bg-dark text-center text-4xl md:text-6xl mx-auto font-bold">
              {servicesTitle}
            </h1>
      </div>
      <div className="from-blue via-blue-700 to-blue-900 bg-gradient-to-b pt pb-12">
        {data.prismicHomepageBodyService.items.map(
          ({ description, title, image, new_or_not }, index) => (
            <Service
              key={index}
              index={index}
              title={title.text}
              desc={description.text}
              img={image.fluid}
              new_or_not={new_or_not}
            />
          )
        )}
      </div>
    </div>
  )
}
